// PACKAGES
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from "prop-types";
import Axios from 'axios';

// FILES
import "./RoomCheckBox.scss"

export class RoomCheckBox extends Component {
    static propTypes = {
        prop: PropTypes
    };

    state = {
        roomName: "",
        productQuantity: 0
    }

    async componentDidMount() {
        // get the quantity value for this room product quantity input field
        let getProductQuantityForThisRoomInputFieldAPIUrl = this.props.APIUrl + "/products/room-product-quantity"
        let data2 = {
            projectId: this.props.projectId,
            SX_Prod_Id: this.props.sx_prod_id ? this.props.sx_prod_id : null,
            roomId: this.props.roomId,

            // we need the 3 below to get non stock product quantity because those don't have product IDs as well as using the room ID with it.
            non_stock_model: this.props.non_stock_model ? this.props.non_stock_model : null, // we use this to check if we are dealing with a non stock product in the backend
            non_stock_title: this.props.non_stock_title ? this.props.non_stock_title : null,
            non_stock_price: this.props.non_stock_price ? this.props.non_stock_price : null
        }

        let getProductQuantityForThisRoomInputFieldAPIResponse = await Axios.post(getProductQuantityForThisRoomInputFieldAPIUrl, data2)
        console.log("here is the value for product quantity ", getProductQuantityForThisRoomInputFieldAPIResponse)
        await this.setState({ productQuantity: getProductQuantityForThisRoomInputFieldAPIResponse.data.productQuantity })
        console.log("here is the value for product quantity state ", this.state.productQuantity)

    }

    render() {
        return (
            <tr class="product-shopping-quantity-input-container">
                <input
                    onBlur={event =>
                        this.props.setQuantityStateFromChildComponent(event.target.value, this.props.roomName, this.props.roomId)//this is how you change the state of a parent component from a child component
                    }
                    onChange={event => (
                        event.target.value !== "" && (isNaN(parseInt(event.target.value)) || !Number.isInteger(parseFloat(event.target.value)) || parseInt(event.target.value) < 0) ? null : this.setState({ productQuantity: "" + parseInt(event.target.value) })
                    )}
                    type="number"
                    min="0"
                    step="1"
                    class="form-control product-shopping-quantity-input"
                    value={this.state.productQuantity}
                />
                <label class="form-check-label" for="materialUnchecked">
                    {this.props.roomName}
                </label>
            </tr>
        )
    }
}

const mapStateToProps = state => ({
    APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RoomCheckBox)
